import { ApiNotFoundComponentModule } from './../_component/api-not-found/api-not-found.component.module';
import { BreadcrumbComponentModule } from './../_component/breadcrumb/breadcrumb.module';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { NoResultModule } from "src/app/app/_component/no-result/no-result.module";
import { SearchBarModule } from "src/app/app/_component/search-bar/search-bar.module";
import { HeaderModule } from "src/app/_component/header/header.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";
import { HomePageModule } from "../home/home.module";
import { MarketPageRoutingModule } from "./market-routing.module";
import { MarketPage } from "./market.page";
import { ProductTileModule } from "./product-tile/product-tile.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MarketPageRoutingModule,
    TranslateModule,
    HeaderModule,
    NoResultModule,
    SearchBarModule,
    SharedDirectivesModule,
    HomePageModule,
    ProductTileModule,
    BreadcrumbComponentModule,
    ApiNotFoundComponentModule
  ],
  declarations: [MarketPage],
})
export class MarketPageModule {}
